module.exports = __webpack_public_path__ + "img/logo.58578ac9.png";